import React, { useState } from 'react';
import { useUserDetialsContext } from '../../context/user-details';
import { returnCapitalizedIndexedCharacter } from '../../utils/returnCapitalizedIndexedCharacter';
import redirectToLogin from '../../utils/token';
import { LogoutIcon } from '../icons/icons';
import ConfirmationModal from '../Modal/ConfirmationModal';

const UserDetails = () => {
  const { userDetails } = useUserDetialsContext();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const { status, image, name, email } = userDetails;

  const handleLogout = () => {
    setShowLogoutModal(false);
    // Clearing the session cookies for user logout
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    redirectToLogin();
  };

  const returnUserProfile = () => {
    if (status) {
      if (image) {
        return <img src={image} alt="Profile" className="h-full w-full" />;
      } else {
        return (
          <div className="h-full w-full bg-[rgba(255,255,255,0.1)] text-xs text-primary flex items-center justify-center gap-[0.09rem]">
            <span>{returnCapitalizedIndexedCharacter(0, name)}</span>
            <span>{returnCapitalizedIndexedCharacter(1, name)}</span>
          </div>
        );
      }
    } else {
      return <div className="w-full h-full bg-slate-700/50 rounded-full animate-pulse" />;
    }
  };

  const returnUserInfo = (val, charLength) => {
    if (val?.length <= charLength) return val;
    else return val?.substring(0, charLength - 3) + '...';
  };

  const returnUserDetails = () => {
    if (status) {
      return (
        <div className="user-details flex flex-col">
          <span className=" text-sm md:text-[13px] leading-5 font-semibold text-white ">
            {returnUserInfo(name, 12)}
          </span>
        </div>
      );
    } else {
      return (
        <div className="user-details hidden sm:flex flex-col gap-1.5 animate-pulse">
          <span className="h-2.5 w-24 bg-slate-700/50 rounded-lg" />
          <span className="h-2 w-20 bg-slate-700/50 rounded-lg" />
        </div>
      );
    }
  };

  const returnLogoutButton = () => {
    if (status) {
      return (
        <button type="button" onClick={() => setShowLogoutModal(true)}>
          <LogoutIcon className="hover:text-primary transition-all duration-200" />
        </button>
      );
    } else {
      return <div className="h-5 w-5 bg-slate-700/50 rounded animate-pulse" />;
    }
  };

  return (
    <div className="user-details-section relative top-[5px]">
      <div className="flex gap-2 justify-between items-center px-3">
        <div className="flex gap-2 items-center">
          <div className="h-8 w-8 rounded-full overflow-hidden">{returnUserProfile()}</div>
          {returnUserDetails()}
        </div>
        {returnLogoutButton()}
        <ConfirmationModal
          title="Are you sure you want to logout?"
          subTitle="If so, select “confirm” to logout."
          confirmationModal={showLogoutModal}
          setConfirmationModal={setShowLogoutModal}
          onConfirm={handleLogout}
        />
      </div>
      <div className="w-full text-center relative bottom-[1px]">
        <span className="text-[10.5px] leading-4 text-[rgba(255,255,255,0.5)] ">
          {returnUserInfo(email, 28)}
        </span>
      </div>
    </div>
  );
};

export default UserDetails;
